import { render, staticRenderFns } from "./StandardRuleActions.vue?vue&type=template&id=8062215e&scoped=true&"
import script from "./StandardRuleActions.vue?vue&type=script&lang=js&"
export * from "./StandardRuleActions.vue?vue&type=script&lang=js&"
import style0 from "./StandardRuleActions.vue?vue&type=style&index=0&id=8062215e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8062215e",
  null
  
)

export default component.exports